import { render, staticRenderFns } from "./ClassroomDetailStudentAddNew.vue?vue&type=template&id=24483348&scoped=true"
import script from "./ClassroomDetailStudentAddNew.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailStudentAddNew.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailStudentAddNew.vue?vue&type=style&index=0&id=24483348&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24483348",
  null
  
)

export default component.exports